import React from "react";
import { Briefcase } from "react-feather";
import { useHasPermission } from "../../auth/useClaims";
import { useBranchFilter } from "../../branchFilter/useBranchFilter";
import { useGetPettyCashSummaryQuery } from "../../pettycash/pettyCashApi";
import { dateRanges, money, percentChange, sumBy } from "../dashboardHelpers";
import KpiCard from "../components/KpiCard";

// Today's petty cash EXPENSE, compared with yesterday - the same shape as
// Today's Collection (2026-09-12, by instruction: "should show the total
// expense of pettycash and not the balance"). The fund balance still lives on
// the Petty Cash by Branch card and the Funds screen.
//
// "Expense" is money actually paid out: the PaidAmount of PAID vouchers from
// GET /pettycash/summary, by the voucher's expense date - the same basis the
// Petty Cash reports use. Requested-but-unpaid vouchers are not spend yet.
//
// Component/file name kept (it is the registry id saved in users' dashboard
// layouts) even though the card no longer shows a balance.
const PettyCashBalanceKpi = () => {
  const canView = useHasPermission("PettyCash.ViewReports");
  const { selectedBranchId } = useBranchFilter();
  const dr = dateRanges();

  const { data: todaySummary, isFetching } = useGetPettyCashSummaryQuery(
    { branchId: selectedBranchId ?? undefined, dateFrom: dr.today, dateTo: dr.today },
    { skip: !canView }
  );
  const { data: yestSummary } = useGetPettyCashSummaryQuery(
    { branchId: selectedBranchId ?? undefined, dateFrom: dr.yesterday, dateTo: dr.yesterday },
    { skip: !canView }
  );

  if (!canView) return null;

  const todayTotal = sumBy(todaySummary, "paidAmount");
  const yesterdayTotal = sumBy(yestSummary, "paidAmount");

  return (
    <div className="col-6 col-xl-3">
      <KpiCard
        icon={<Briefcase size={20} />}
        iconBg="#2E7D32"
        label="Today's Petty Cash Expense"
        value={isFetching ? "..." : money(todayTotal)}
        trendLabel="vs Yesterday"
        trendPercent={percentChange(todayTotal, yesterdayTotal)}
        currentValue={todayTotal}
        comparisonValue={yesterdayTotal}
        compareRangeLabel={dr.yesterday}
      />
    </div>
  );
};

export default PettyCashBalanceKpi;
